import useAxios from 'hooks/useAxios';

export async function kickAllSessions(reason) {
  const api = useAxios();

  try {
    const res = await api.post('/queue/admin/kick-all-sessions', { reason });
    return res;
  } catch (err) {
    return err;
  }
}
